import React, { useState } from "react";
import "./style.scss";
import { Steps, Input, Table, Button, message } from "antd";
import { PlusCircleOutlined, DeleteOutlined } from "@ant-design/icons";
import { useEffect } from "react";
import PosService from "../../../services/PosService";
import { v4 as uuidv4 } from 'uuid';
import debounce from 'lodash.debounce'

const TableDetails = ({ data, setData, adminRestaurant }) => {
  const [sectionData, setSectionData] = useState([]);
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    setTableData(data.tableData || []);
    setSectionData(data.sectionData || []);
  }, [data]);

  const addRowTable = () => {
    setTableData((prev) => [...prev, {id: uuidv4(),occupancy:"",number_of_table:""}]);
  };

  const addRowSection = () => {
    setSectionData((prev) => [...prev, {id: uuidv4(),floor:"",name:""}]);
  };

  const removeRow = (idx,type) => {
    if(type=="table")
     setTableData(tableData.filter(item=>item.id !==idx.id))
    else
    setSectionData(sectionData.filter(item=>item.id !==idx.id)) 
  };

 const handleSearch = debounce((e, type,record)=>{

  if(type == "floor")
  {
    const getValue = sectionData.find(item=>item.floor == e.target.value)
    if(getValue && e.target.value.length>0)
     message.error("Floor already exists")
    else 
    setSectionData((data) => {
      const result = [...data]
      const getValue = result.findIndex(item=>item.id=== record.id)
      result[getValue][type] = e.target.value;
      return result;
    });
  }
  else
  setSectionData((data) => {
    const result = [...data]
    const getValue = result.findIndex(item=>item.id=== record.id)
    result[getValue][type] = e.target.value;
    return result;
  });

 },500)

  const onChangeSection = (e, type,record) => {
    handleSearch(e, type,record)
    
  };

  const updateTypeCount = (e, type,record) => {
    setTableData((data) => {
      const result = [...data]
      const getValue = result.findIndex(item=>item.id=== record.id)
      result[getValue][type] = e.target.value;
      return result;
    });
  };

  const saveTable = async () => {
   
    if(current == 2)
     return
    next()
    const floorData = sectionData.map(item=>{
      const obj ={
        floor:parseInt(item.floor),
        name: item.name,
        
      }
      return obj;
    });
    const occupancyData = tableData.map(item=>{
      const obj ={
        occupancy:parseInt(item.occupancy),
        number_of_table: parseInt(item.number_of_table),
        
      }
      return obj;
    })
    setData({
      sectionData:floorData,
        tableData: occupancyData,
    })
    
  };


  const steps = [
    {
      title: 'Floor',
      content: <div>
      <div style={{ padding: "1rem" }}>
      <h3 className="table-management-card-title-data">Add Floor Details</h3>
            <a style={{ float: "right" }} onClick={addRowSection}>
              Add Floor
              <PlusCircleOutlined style={{ margin: ".5rem" }} />
            </a>
      </div>
      <Table
      dataSource={sectionData}
      pagination = {false}
      columns={[
        {
          title: "Enter Floor",
          dataIndex: "floor",
          key: "floor",
          render: (e, record) => (
            <div className="table-row-div">
            <Input
              placeholder="Enter value"
              name={"floor"}
              defaultValue={record.floor}
              onChange={(e) => onChangeSection(e, "floor",record)}
            />
            </div>
          ),
        },
        {
          title: "Number of Sections on Floor",
          dataIndex: "section",
          key: "section",
          render: (e, record) => (
            <div className="table-row-div">
            <Input
              placeholder="Enter value"
              name="section"
              defaultValue={record.name}
              onChange={(e) => onChangeSection(e, "name",record)}
            />
            </div>
          ),
        },
        {
          title: "Action",
          render: (e, record) => (
            <div className="table-row-div">
            <a onClick={() => removeRow(record,"floor")}>
              <DeleteOutlined />
            </a>
            </div>
          ),
        },
      ]}
    />
    </div>
    },
    {
      title: 'Table',
      content: <div>
        <div style={{ padding: "1rem" }}>
        <h3 className="table-management-card-title-data">Add Table Details</h3>
            <a style={{ float: "right" }} onClick={addRowTable}>
              Add Table Type
              <PlusCircleOutlined style={{ margin: ".5rem" }} />
            </a>
          </div>
          <Table
            dataSource={tableData}
            pagination = {false}
            columns={[
              {
                title: "Table Occupancy",
                dataIndex: "occupancy",
                key: "occupancy",
                render: (e, record) => (
                  <div className="table-row-div">
                  <Input
                    
                    placeholder="Enter value"
                    defaultValue={record.occupancy}
                    onChange={(e) =>
                      updateTypeCount(e, "occupancy",record)
                    }
                  />
                  </div>
                ),
              },
              {
                title: "Number of tables",
                dataIndex: "count",
                key: "count",
                render: (e, record) => (
                  <div className="table-row-div">
                  <Input
                    
                    placeholder="Enter value"
                    defaultValue={record.number_of_table}
                    onChange={(e) =>
                      updateTypeCount(e, "number_of_table",record)
                    }
                  />
                  </div>
                ),
              },
              {
                title: "Action",
                render: (e,record) => (
                  <div className="table-row-div">
                  <a onClick={() => removeRow(record,"table")}>
                    <DeleteOutlined />
                  </a>
                  </div>
                ),
              },
            ]}
          />
      </div>,
    }
  ];

  const [current, setCurrent] = useState(0);
  const next = () => {
    setCurrent(current + 1);
  };
  const prev = () => {
    setCurrent(current - 1);
  };
  
  const steps1 = [
    {
      title: 'Enter Floor Details',
      key: 'First',
    },
    {
      title: 'Enter Table Details',
      key: 'Second',
     
    },
    {
      title: 'Setup Map',
      key: 'Last',
     
    },
  ];

  const items = steps1.map((item) => ({
    key: item.title,
    title: item.title,
  }));

  const Stepper = ({ steps, current }) => {
    return (
      <div className="stepper">
        {steps.map((step, index) => {
          const isCompleted = index < current;
          const isActive = index === current;
          return (
            <div className="step" key={index}>
              <div
                className={`circle ${isCompleted || isActive ? "activeStep" : ""}`}
              ></div>
              {index !== steps.length - 1 && (
                <div
                  className={`line ${
                    isCompleted ? "active" : ""
                  }`}
                ></div>
              )}
              <div
                className={`label ${
                  isCompleted || isActive ? "activeStep" : ""
                }`}
              >
                {step?.title}
              </div>
            </div>
          );
        })}
      </div>
    );
  };
   
  return (
    <div className="table-management-card">
      <h2 className="table-management-card-title">Add Details</h2>

      <div>
      <Stepper steps={items} current={current} />
</div>
      
    
    
      <div className="table-contents">{steps[current==2?1:current]?.content}</div>
      <div
      className="nex-prev-btn"
      >
        {current < steps.length - 1 && (
          <Button type="primary" className="custom-btn" onClick={() => next()}>
            Next
          </Button>
        )}
        {current !== 0 && current !== 2 &&(
          <Button type="primary" className="custom-btn" onClick={saveTable}>
            Save
          </Button>
        )}
        {current > 0 && (
          <Button
            style={{
              margin: '0 8px',
            }}
            className="custom-btn"
            onClick={() => prev()}
          >
            Previous
          </Button>
        )}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          margin: "1rem",
        }}
      >
      </div>
    </div>
  );
};

export default TableDetails;
